/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_View_PieInputs */

const en_admin_ai_chat_view_pie = /** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pie`)
};

const de_admin_ai_chat_view_pie = /** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreis`)
};

const es_admin_ai_chat_view_pie = /** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circular`)
};

const fr_admin_ai_chat_view_pie = /** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secteurs`)
};

const nl_admin_ai_chat_view_pie = /** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taart`)
};

/** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */
const it_admin_ai_chat_view_pie = en_admin_ai_chat_view_pie;

/** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_view_pie = en_admin_ai_chat_view_pie;

/** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */
const pl_admin_ai_chat_view_pie = en_admin_ai_chat_view_pie;

/** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */
const hu_admin_ai_chat_view_pie = en_admin_ai_chat_view_pie;

/** @type {(inputs: Admin_Ai_Chat_View_PieInputs) => LocalizedString} */
const ro_admin_ai_chat_view_pie = en_admin_ai_chat_view_pie;

/**
* | output |
* | --- |
* | "Pie" |
*
* @param {Admin_Ai_Chat_View_PieInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_view_pie = /** @type {((inputs?: Admin_Ai_Chat_View_PieInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_View_PieInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_view_pie(inputs)
	if (locale === "de") return de_admin_ai_chat_view_pie(inputs)
	if (locale === "es") return es_admin_ai_chat_view_pie(inputs)
	if (locale === "fr") return fr_admin_ai_chat_view_pie(inputs)
	if (locale === "nl") return nl_admin_ai_chat_view_pie(inputs)
	if (locale === "it") return it_admin_ai_chat_view_pie(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_view_pie(inputs)
	if (locale === "pl") return pl_admin_ai_chat_view_pie(inputs)
	if (locale === "hu") return hu_admin_ai_chat_view_pie(inputs)
	return ro_admin_ai_chat_view_pie(inputs)
});
export { admin_ai_chat_view_pie as "admin.ai_chat.view_pie" }